import { useCallback, useEffect, useState } from "react";
import { getListTemplateImport } from "../../services/uploadFile";

const useListTemplateImport = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getListTemplateImport();
    if (res.data.code === "0000") {
      console.log("list file==>");
      console.log(res.data);
 /*     
  const obj = {
  dataId: '83f87c3d-89aa-4745-a326-58770b0f0e7e',
  dataDetailEn: 'Customer_in_the_estate.xlsx',
  dataDetailTh: 'ข้อมูลโครงสร้างองค์กร.xlsx',
  dataTopic: 'file_template_list'
};
const obj_2 = {
  dataId: '83f87c3d-89aa-4745-a326-58770b0f0e7e',
  dataDetailEn: 'Customer_in_the_estate.xlsx',
  dataDetailTh: 'ข้อมูลพนักงาน.xlsx',
  dataTopic: 'file_template_list'
};
res.data.objectValue.push(obj); 
res.data.objectValue.push(obj_2); 
*/


      const { objectValue } = res.data;
       

      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useListTemplateImport;
